<template>
  <form-field v-bind="$attrs" :title="title" :is-link="isLink" :is-require="isRequire">
    <div class="input-control">
      <input class="input-inner" :type="type" :value="value" v-bind="$attrs" v-on="listeners">
      <div v-if="unit" class="input-unit">{{ unit }}</div>
      <div v-if="showLimit" class="input-limit">{{ value.length }}/{{ $attrs.maxlength }}</div>
      <slot name="append-icon" />
    </div>
  </form-field>
</template>
<style lang="less" scoped>
.input-control {
  display: flex;
  align-items: center;
  .input-inner {
    flex: 1;
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: #323233;
    line-height: inherit;
    text-align: left;
    background-color: transparent;
    border: 0;
    resize: none;
    &::placeholder {
      font-size: 2rem;
      color: #bbb;
    }
  }
  .input-unit {
    flex-shrink: 0;
    font-size: 28px;
    color: #bbb;
  }
  .input-limit {
    flex-shrink: 0;
    font-size: 26px;
    color: #666;
  }
}
</style>

<script>
export default {
  name: 'FormInput',
  inheritAttrs: false,
  props: {
    value: [String, Number, Array],
    title: String,
    unit: String,
    isLink: {
      type: Boolean,
      default: false,
    },
    isRequire: {
      type: Boolean,
      default: false,
    },
    showLimit: {
      type: Boolean,
      default: false,
    },
    onlyNumber: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: e => {
          let val = e.target.value;
          if (this.onlyNumber) {
            e.target.value = val === '0' ? '' : val.replace(/\D/g, '');
          }
          this.$emit('input', e.target.value);
        },
      };
    },
  },
};
</script>
